module.exports = __webpack_public_path__ + "img/banner8.dd6a50ba.png";